// extracted by mini-css-extract-plugin
export default {"Modal":"MyPointsInfo_Modal__ZH7w4"};